import { render } from "./Heading.vue?vue&type=template&id=380343f0&scoped=true"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=380343f0&lang=scss&scoped=true"

import exportComponent from "/var/www/carteCiel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380343f0"]])

export default __exports__